import React, { useState } from "react";
import { Modal, Button, Dropdown, ButtonGroup } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as alertActions from "../../redux/actions/alertAction";

import { myUtilities } from "../../Utils";

const AlertDropdown = (props) => {
  const defaultCardType = myUtilities.accountSpecificLanguage(
    "AlertDialog.DefaultCardType",
    "Select card type"
  );

  const [cardType, setCardType] = useState(defaultCardType);

  const dropDownMap = props.invData?.state?.cardTypesDropdown
    ? Object.entries(props.invData.state.cardTypesDropdown)
    : [];

  return (
    <Modal
      show={props.alert.showDropdownAlert}
      onHide={async () => {
        await props.paymentData.resetCardType();
        props.alertActions.hideDropdownALert();
      }}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {myUtilities.accountSpecificLanguage("Alert.Header", "Alert!")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {myUtilities.accountSpecificLanguage(
          "AlertDialog.DefaultCardType",
          "Select card type"
        )}
        <Dropdown
          className="cardtype-dropdown"
          onSelect={(evt) => setCardType(evt)}
          as={ButtonGroup}
        >
          <Button id="dropdown-button-main" variant="success">
            <span id="lang-dropdown-text">{cardType === defaultCardType ? cardType : props.invData.state.cardTypesDropdown[cardType]}</span>
          </Button>

          <Dropdown.Toggle split variant="success" id="dropdown-split-basic" />
       
          <Dropdown.Menu>
            {dropDownMap.map((dropMap, index) => {
              return <Dropdown.Item key={dropMap[0]} eventKey={dropMap[0]}>
                {dropMap[1]}
              </Dropdown.Item>
            }
            )}
          </Dropdown.Menu>
        </Dropdown>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={async () => {
            if(cardType===defaultCardType) return;
            await props.paymentData.setCardType(cardType);
            props.onClickConfirm(props.paymentData, props.invData);
            props.alertActions.hideDropdownALert();
          }}
        >
          {myUtilities.accountSpecificLanguage("AlertDialog.Ok", "Ok")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  alert: state.commonAlerts,
});

const mapDispatchToProps = (dispatch) => ({
  alertActions: bindActionCreators(alertActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AlertDropdown);
